import { render, staticRenderFns } from "./ModalAssinarDocumento.vue?vue&type=template&id=27304fd2&"
import script from "./ModalAssinarDocumento.vue?vue&type=script&lang=js&"
export * from "./ModalAssinarDocumento.vue?vue&type=script&lang=js&"
import style0 from "./ModalAssinarDocumento.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports